type ScrollObserverCallback = (isIntersecting: boolean) => void

type ScrollObserverOptions = {
  root?: Element | null
  rootMargin?: string
  threshold?: number | number[]
}

export class ScrollObserver {
  private observer: IntersectionObserver | null = null

  constructor(
    private readonly $target: Element,
    private readonly callback: ScrollObserverCallback,
    private readonly options: ScrollObserverOptions = {},
  ) {
    this.observe()
  }

  observe(): void {
    this.disconnect()

    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0]

        if (entry !== undefined) {
          this.callback(entry.isIntersecting)
        }
      },
      {
        root: this.options.root ?? null,
        rootMargin: this.options.rootMargin ?? '0px',
        threshold: this.options.threshold ?? 0,
      },
    )

    this.observer.observe(this.$target)
  }

  disconnect(): void {
    this.observer?.disconnect()
    this.observer = null
  }
}
